import { inject, provide } from 'vue';

import type { IGroupItemProvide } from '@components/composable';
import type { InjectionKey, Ref } from 'vue';

export interface ICdsCardProvide {
  rootRef: Ref<HTMLElement | undefined>;
  multiple: Ref<boolean>;
}

export const CdsCardSymbol: InjectionKey<ICdsCardProvide> = Symbol.for('cds:card');
export const CdsCardGroupSymbol: InjectionKey<IGroupItemProvide> = Symbol.for('cds:card-group');

export const useProvideCard = (data: ICdsCardProvide) => {
  provide(CdsCardSymbol, data);
};

export const useInjectCard = () => {
  return inject(CdsCardSymbol, {} as ICdsCardProvide);
};
